<template>
  <div class="code-wrapper">
    <div v-if="voucher.displayMode === 'STRING'" class="string-code">
        <div class="code">
          {{ voucher.voucherCode }}
        </div>
        <button class="copy-button" @click="onCopyButtonClick">
          <confirm-icon v-if="voucherCopied" iconClass="icon" color="black" />
          <copy-icon v-else iconClass="icon" />
          <div class="button-text">
            {{ $t('discount.voucher.voucher.copyButton') }}
          </div>
        </button>
    </div>
    <div v-else class="barcode-wrapper" :class="qrCodeClass">
      <img class="voucher-barcode" :src="voucherBarcode" />
    </div>
  </div>
</template>
<style scoped>
  .copy-button {
    background-color: white;
    border: none;
    display: flex;
    align-items: center;
  }
  .string-code {
    display: flex;
    align-items: center;
    margin: 16px 0;
  }
  .code {
    margin-right: 70px;
    font-size: 28px;
    font-weight: bold;
  }
  .icon {
    margin: 6px;
  }
  .voucher-barcode {
    max-height: 200px;
  }
  .barcode-wrapper {
    min-height: 100px;
    margin: 16px 0;
  }
  .qr-code {
    margin: 0;
  }
  @media (max-width: 400px) {
    .code-wrapper {
      flex-direction: column;
    }
  }
</style>
<script>
import { mapState } from 'vuex';
import CopyIcon from '../icons/CopyIcon.vue';
import ConfirmIcon from '../icons/ConfirmIcon.vue';

export default {
  name: 'voucher-display',
  props: {
    voucher: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      voucherBarcode: (state) => state.voucher.voucherBarcode,
    }),
    qrCodeClass() {
      return this.voucher.displayMode === 'QR_CODE' ? 'qr-code' : '';
    },
  },
  methods: {
    onCopyButtonClick() {
      this.voucherCopied = true;
      navigator.clipboard.writeText(this.voucher.voucherCode);
    },
  },
  components: {
    CopyIcon,
    ConfirmIcon,
  },
  data() {
    return {
      voucherCopied: false,
    };
  },
};
</script>
